module.exports = __webpack_public_path__ + "static/media/WiBox_in.bf697adb.jpg";